import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ResourcesService {

  //#region Public properties
  readonly urls: any;
  readonly Labels: any;
  readonly routes: any;
  readonly columnDefinitions: any;
  readonly dateFormats: any;
  readonly notesStatuses: any;
  readonly responseMessages: any;
  readonly modalText: any;

  //#endregion

  //#region Constructor
  constructor() {
    //URLs
    this.urls = {
      host: {
        services: {
          DMS: {
            generateOutlookToken: 'DMS/GenerateOutlookToken'
          },
          Drawer: {
            indexes: "Drawer/Indexes"
          },
          Index: {
            searchLookup: 'Index/SearchLookup'
          },
          TRPCAdmin: {
            getDrawerList: "TRPCAdmin/GetDrawerList",
            getWorkFlowList: 'TRPCAdmin/GetWorkFlowList',
            getTRPCList: 'TRPCAdmin/GetTRPCList',
            getServiceTypeList: 'TRPCAdmin/GetServiceTypeList',
            getMultipleTrpcData: 'TRPCAdmin/GetMultipleTrpcData',
            getInfoTabConfig: 'TRPCAdmin/GetInfoTabConfig',
            getWorkFlowSteps: 'TRPCAdmin/GetWorkFlowSteps',
            getScanUsers: 'TRPCAdmin/GetScanUsers',
            getCompletionStep: 'TRPCAdmin/GetCompletionStep',
            TRPCRouteUsers4Group: 'TRPCAdmin/TRPCRouteUsers4Group',
            checkRouteNotification: 'TRPCAdmin/CheckRouteNotification',
          },
          TRPC: {
            searchETaxFolders: 'TRPC/SearchETaxFolders',
            searchETaxFolders4Export: 'TRPC/SearchETaxFolders4Export',
            getUserRights: 'TRPC/GetUserRights',
            getDrawerRights: 'TRPC/GetDrawerRights'
          },
          Firmflow: {
            loadWorkflowRouteUsers: 'Firmflow/LoadWorkflowRouteUsers',
            loadWorkflowRouteGroups: 'Firmflow/LoadWorkflowRouteGroups',
            loadPicUsers: {
              'all': 'Firmflow/LoadAllPicUsersForScreen',
              'serviceType': 'Firmflow/LoadPicUsersForScreen'
            }
          },
          TaxFolder: {
            indexes: "TaxFolder/Indexes",
            getFolder: "TaxFolder/GetFolder",
            addFolder: "TaxFolder/AddFolder",
            deleteFolder: "TaxFolder/DeleteFolder",
            updateFolder: "TaxFolder/UpdateFolder"
          },
          UserPreferences: {
            getScreenPreferences: "UserPreferences/GetScreenPreferences",
            getTemplate: "UserPreferences/GetTemplate",
            saveScreenPrefs: "UserPreferences/SaveScreenPrefs"
          },
          Note: {
            loadNotes: "Note/LoadNotes",
            saveFilingNote: "Note/SaveFilingNote",
            addFilingNote: "Note/AddFilingNote",
            editFilingNote: "Note/EditFilingNote",
            getTabNoteTypeId: "Note/GetTabNoteTypeId"
          },
          Filing: {
            resetChecklists: "Filing/resetChecklists",
            getFilings: "Filing/GetFilings"
          },
          Route: {
            checkFilings4Route: "Route/CheckFilings4Route",
            getNextAssigned: "Route/GetNextAssigned",
            add: "Route/Add"
          }
        }
      }
    }

    this.Labels = {
      SearchWorkFlows: {
        ToolBar: {
          Options: {
            Add: 'Add',
            Route: 'Route',
            Email: {
              mainLabel: 'Email',
              options: {
                Outlook: 'Email Workflow(s) using Outlook',
                GoFileRoom: 'Email Workflow(s) using GoFileRoom'
              }
            },
            OpenTaxReturn: 'Open Tax Return',
            Export: 'Export',
            Manage: {
              mainLabel: 'Manage',
              options: {
                ResetCheckLists: 'Reset Checklists',
                ViewControlSheets: 'View Control Sheets'
              }
            },
            Delete: 'Delete'
          }
        },
        Email: {
          WorkflowLink: 'Click here to retrieve the list of GoFileRoom - FirmFlow Workflow(s) sent to you.',
          RouteLink: 'Click here to retrieve the list of GoFileRoom - FirmFlow Workflow(s) assigned to you.'
        }
      },
      WorkflowPage: {
        notes: {
          Toolbar: {
            Add: 'Add',
            ReplyWithQuote: 'Reply with Quote',
            Delete: 'Delete'
          }
        }
      }
    }

    this.routes = {
      searchWorkflows: '/searchworkflows',
      workflowPage: {
        main: '/workflow-page',
        notes: '/workflow-page/notes'
      },
      addWorkFlow: '/addWorkflow',
      taxFolder: '/taxFolder'
    }

    this.columnDefinitions = {
      workflowPage: {
        notes: {
          'actions': {
            binding: 'actions',
            header: 'Actions',
            hasFilter: false,
            minWidth: 76,
            width: 76,
            allowSorting: false,
            allowDragging: false,
            isReadOnly: true
          },

          'notes': {
            binding: 'notes',
            header: 'Note',
            hasFilter: false,
            visible: true,
            allowSorting: false,
            allowDragging: false,
            isReadOnly: true,
            width: '*',
            minWidth: 400,

          },

          'notes_updated_date': {
            binding: 'notes_updated_date',
            header: 'Lastest Note At',
            minWidth: 170,
            hasFilter: false,
            visible: true,
            allowSorting: false,
            allowDragging: false,
            isReadOnly: true,
            width: '*'
          },

          'notes_updated_by': {
            binding: 'notes_updated_by',
            header: 'Lastest Note By',
            hasFilter: true,
            visible: true,
            allowSorting: false,
            allowDragging: false,
            isReadOnly: true,
            width: '*'
          },

          'note_type_id': {
            binding: 'note_type_id',
            header: 'Type',
            hasFilter: true,
            visible: true,
            allowSorting: false,
            allowDragging: false,
            isReadOnly: true,
            width: '*'
          },

          'status_id': {
            binding: 'status_id',
            header: 'Status',
            hasFilter: true,
            visible: true,
            allowSorting: false,
            allowDragging: false,
            isReadOnly: false,
            width: '*'
          },

          'status_updated_by': {
            binding: 'status_updated_by',
            header: 'Lastest Status By',
            hasFilter: false,
            visible: true,
            allowSorting: false,
            allowDragging: false,
            isReadOnly: true,
            width: '*'
          },

          'status_updated_date': {
            binding: 'status_updated_date',
            header: 'Lastest Status At',
            minWidth: 170,
            hasFilter: false,
            visible: true,
            allowSorting: false,
            allowDragging: false,
            isReadOnly: true,
            width: '*'
          }
        },
        filings:{
          'actions': {
            binding: 'actions',
            header: 'Actions',
            hasFilter: false,
            minWidth: 82,
            width: 82,
            allowSorting: false,
            allowDragging: false,
            isReadOnly: true
          },

          'workflow': {
            binding: 'workflow',
            header: 'Workflow Name',
            hasFilter: true,
            visible: true,
            allowSorting: true,
            allowDragging: false,
            isReadOnly: true,
            width: '*',
            minWidth: 220,

          },

          'extended': {
            binding: 'extended',
            header: 'Extended',
            minWidth: 166,
            hasFilter: true,
            visible: true,
            allowSorting: true,
            allowDragging: false,
            isReadOnly: true,
            width: '*'
          },

          'filing_name': {
            binding: 'filing_name',
            header: 'Description',
            hasFilter: true,
            minWidth: 300,
            visible: true,
            allowSorting: true,
            allowDragging: false,
            isReadOnly: true,
            width: '*'
          },

          'due_date': {
            binding: 'due_date',
            header: 'Due Date',
            hasFilter: true,
            visible: true,
            allowSorting: true,
            allowDragging: false,
            isReadOnly: true,
            width: '*',
            minWidth: 140,
            maxWidth: 170,
          },

          'assigned_to': {
            binding: 'assigned_to',
            header: 'Assigned To',
            hasFilter: true,
            visible: true,
            allowSorting: true,
            allowDragging: false,
            isReadOnly: false,
            width: '*',
            minWidth: 210
          },

          'current_step': {
            binding: 'current_step',
            header: 'Step',
            hasFilter: true,
            visible: true,
            allowSorting: true,
            allowDragging: false,
            isReadOnly: true,
            width: '*'
          },

          'assigned_date': {
            binding: 'assigned_date',
            header: 'Routing Date',
            minWidth: 140,
            hasFilter: true,
            visible: true,
            allowSorting: true,
            allowDragging: false,
            isReadOnly: true,
            width: '*'
          },

          'status': {
            binding: 'status',
            header: 'Status',
            minWidth: 210,
            hasFilter: true,
            visible: true,
            allowSorting: true,
            allowDragging: false,
            isReadOnly: true,
            width: '*'
        }
      }
    }
    }

    this.dateFormats = {
      'MM/DD/YYYY': /^(0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])[/](19|20)\d\d$/,
      'MM.DD.YYYY': /^(0[1-9]|1[012])[.](0[1-9]|[12][0-9]|3[01])[.](19|20)\d\d$/,
      'MM-DD-YYYY': /^(0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])[-](19|20)\d\d$/,
      'DD/MM/YYYY': /^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19|20)\d\d$/,
      'DD.MM.YYYY': /^(0[1-9]|[12][0-9]|3[01])[.](0[1-9]|1[012])[.](19|20)\d\d$/,
      'DD-MM-YYYY': /^(0[1-9]|[12][0-9]|3[01])[-](0[1-9]|1[012])[-](19|20)\d\d$/,
      'YYYY/MM/DD': /^(19|20)\d\d[/](0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])$/,
      'YYYY.MM.DD': /^(19|20)\d\d[.](0[1-9]|1[012])[.](0[1-9]|[12][0-9]|3[01])$/,
      'YYYY-MM-DD': /^(19|20)\d\d[-](0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])$/,
      range: {
        'MM/DD/YYYY': /^(0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])[/](19|20)\d\d[-](0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])[/](19|20)\d\d$/,
        'MM.DD.YYYY': /^(0[1-9]|1[012])[.](0[1-9]|[12][0-9]|3[01])[.](19|20)\d\d[-](0[1-9]|1[012])[.](0[1-9]|[12][0-9]|3[01])[.](19|20)\d\d$/,
        'MM-DD-YYYY': /^(0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])[-](19|20)\d\d[-](0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])[-](19|20)\d\d$/,
        'DD/MM/YYYY': /^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19|20)\d\d[-](0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19|20)\d\d$/,
        'DD.MM.YYYY': /^(0[1-9]|[12][0-9]|3[01])[.](0[1-9]|1[012])[.](19|20)\d\d[-](0[1-9]|[12][0-9]|3[01])[.](0[1-9]|1[012])[.](19|20)\d\d$/,
        'DD-MM-YYYY': /^(0[1-9]|[12][0-9]|3[01])[-](0[1-9]|1[012])[-](19|20)\d\d[-](0[1-9]|[12][0-9]|3[01])[-](0[1-9]|1[012])[-](19|20)\d\d$/,
        'YYYY/MM/DD': /^(19|20)\d\d[/](0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])[-](19|20)\d\d[/](0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])$/,
        'YYYY.MM.DD': /^(19|20)\d\d[.](0[1-9]|1[012])[.](0[1-9]|[12][0-9]|3[01])[-](19|20)\d\d[.](0[1-9]|1[012])[.](0[1-9]|[12][0-9]|3[01])$/,
        'YYYY-MM-DD': /^(19|20)\d\d[-](0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])[-](19|20)\d\d[-](0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])$/,
      }
    }

    this.notesStatuses = {
      'Open': 'badge-open',
      'Closed': 'badge-closed',
      'Deleted': 'badge-deleted'
    }

    this.responseMessages = {
      workflowPage: {
        notes: {
          0: {
            'success': 'The note status has been successfully updated.',
            'danger': 'We were unable to process your request at this time. Please try it again later.'
          },
          1: {
            'success': 'A note has been successfully added.',
            'danger': 'We were unable to process your request at this time. Please try it again later.'
          },
          2: {
            'success': 'The note has been successfully edited.',
            'danger': 'We were unable to process your request at this time. Please try it again later.'
          },
          3: {
            'success': 'The note reply has been successfully added.',
            'danger': 'We were unable to process your request at this time. Please try it again later.'
          },
          4: {
            'success': 'The note reply has been successfully added.',
            'danger': 'We were unable to process your request at this time. Please try it again later.'
          },
          5: {
            'success': 'The note(s) have been successfully deleted.',
            'danger': 'We were unable to process your request at this time. Please try it again later.'
          }
        }
      },
      workflows: {
        1: {
          'success': 'The Checklist(s) have been successfully reset.',
          'danger': 'We were unable to process your request at this time. Please try it again later.'
        },
        2: {
          'success': 'The Workflow(s) have been successfully deleted.',
          'danger': 'We were unable to process your request at this time. Please try it again later.'
        },
        5: {
          'success': 'The Tax Folder has been successfully edited.',
          'danger': 'We were unable to process your request at this time. Please try it again later.'
        },
        4: {
          'success': 'The Workflow(s) have been successfully routed.',
          'danger': 'We were unable to process your request at this time. Please try it again later.',
          'info': {
            2: "One or more workflow(s) are in the final step.",
            3: "You do not have rights to route to the final step.",
            4: "One or more workflow(s) do not have next assigned user.",
            5: "All selected workflows should be the same type."
          }
        }
      }
    }

    this.modalText = {
      workflowPage: {
        notes: {
          titleText: {
            0: 'Are you sure you want to change the status?',
            1: 'Add Note',
            2: 'Edit Note',
            3: 'Reply to Note',
            4: 'Reply with Quote',
            5: 'Are you sure you want to delete the note(s)?'
          },

          bodyText: {
            0: 'When you change the status for a parent note to {0}, the status for the child note also changes to {0}.\n\nDo you want to proceed?',
            5: null
          },

          confirmButtonText: {
            0: 'Change',
            1: 'Add',
            2: 'Edit',
            3: 'Reply',
            4: 'Reply',
            5: 'Delete'
          }
        }
      },
      workflows: {
        titleText: {
          0: 'Error',
          1: 'Are you sure you want to reset the Checklist(s)?',
          2: 'Are you sure you want to delete the Workflow(s)?',
          6: 'Are you sure you want to exit without saving changes?'
        },

        bodyText: {
          0: 'Please narrow down your search results.',
          1: null,
          2: null,
          6: null
        },

        confirmButtonText: {
          0: 'Ok',
          1: 'Reset',
          2: 'Delete',
          6: 'Exit'
        },

        closeButtonText: {
          0: null,
          1: 'Cancel',
          2: 'Cancel',
          6: 'Cancel'
        }
      }
    }
  }

  //#endregion
}
